<div class="oi-left-main side-panel" [ngClass]="sidebarVisibility?'sidefixd':''">
  <div class="oi-left-logo-mn d-flex" routerLinkActive="active">
    <div class="oiheader-left-new" >
      <div class="logo">
        <!-- <a href="javascipt:void(0)"> -->
          <img src="assets/img/logo-circle.svg">
        <!-- </a> -->
      </div>
      <div class="text">neInsight</div>
    </div>
    <div class="oi-header-toggle-btn" (click)="isMobile ? null : showhidesidebar()">
      <svg  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="panel-right-open" class=""><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M15 3v18"></path><path d="m10 15-3-3 3-3"></path></svg>
    </div>
   
  </div>
  <div class="oi-menu-left">
    <div class="oi-header-toggle-btn1" (click)="isMobile ? null : showhidesidebar()">
      <svg  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="panel-right-open" class=""><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="M15 3v18"></path><path d="m10 15-3-3 3-3"></path></svg>
    </div>
    <ul>
      <li>
        <a href="javascript:void(0)" routerLink="/get-answer" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/get-answers.svg">
          </span> <span class="text">Get Answers</span></a>
      </li>
      
      <li>
        <a href="javascript:void(0)" routerLink="/saved-answer" routerLinkActive="active"   (click)="reloadSavedAnswer($event)"><span class="icon">
          <img src="../../assets/img/history.svg">  
        </span> <span class="text">History</span>
        </a>
      </li>

      <li >
        <a href="javascript:void(0)" routerLink="/knowledgehub" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/knowledge-hub.svg">
          </span> <span class="text">Knowledge Hub</span>
        </a>
      </li>

      <li>
        <a href="javascript:void(0)" routerLink="/trending-question" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/trending.svg">
          </span> <span class="text">Popular Questions</span>
        </a>
      </li>
      <li >
        <a href="javascript:void(0)" routerLink="/question-answer" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/faq-icon.svg">
          </span> <span class="text">Search Q&A</span>
        </a>
      </li>

       <li>
        <a href="javascript:void(0)" routerLink="/dashboard" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/report.svg">
          </span> <span class="text">Quick Reports</span>
        </a>
      </li>
      <!-- <li class="oi-tw-line-nav"> -->
        <!-- <a href="javascript:void(0)" routerLink="/task-work" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/taskwork.svg">
          </span> <span class="text">TaskWork</span>
        </a>-->
        <!-- <div class="oi-accordian-lt-toggle" (click)="isMobile ? null : showhidesidebar()">
          <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M6 9l6 6l6 -6" /></svg>
        </div>
        <div class="oi-accordian-lt">
          <p-accordion>
            <p-accordionTab header="Task Work" (click)="onTaskWorkClick()">
              <ul class="task-list">
                <li *ngFor="let temp of DefaultPrompts" 
                    [class.active]="selectedTemplate?.template_code == temp.template_code"
                    (click)="selectTemplate(temp)"> -->
                  
                  <!-- Icon switch based on template_code -->
                  <!-- <ng-container *ngIf="temp.template_code === 'SYSTASK'; else defaultIcon">
                    <svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M11.482 20.924a1.666 1.666 0 0 1 -1.157 -1.241a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.312 .318 1.644 1.794 .995 2.697" /><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M20 21l2 -2l-2 -2" /><path d="M17 17l-2 2l2 2" /></svg>
                   
                  </ng-container>
                  <ng-template #defaultIcon>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                         stroke-linecap="round" stroke-linejoin="round">
                      <path d="M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                      <path d="M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                      <path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                      <path d="M8.7 10.7l6.6 -3.4" />
                      <path d="M8.7 13.3l6.6 3.4" />
                    </svg>
                  </ng-template>
        
                  <span>{{ temp.template_name }}</span>
                </li>
              </ul> -->
              <!-- <button pButton label="+ New Task" class="new-task-btn" (click)="addNewTask()"></button> -->
            <!-- </p-accordionTab>
          </p-accordion>
        </div>
        
        
        
      </li> -->

      <!-- <li class="oi-tw-line-nav" *ngIf="isEnableDataInsight">
        <a href="javascript:void(0)" routerLink="/data-insight" routerLinkActive="active"><span class="icon">
          <img src="../../assets/img/database.svg">
          </span> <span class="text">Data Insight®</span>
        </a>
      </li> -->

     
      <!-- <li *ngIf="role=== 'admin'">
        <a href="javascript:void(0)"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
          </svg>
          </span> <span class="text">Create Users </span>
        </a>
      </li> -->

    </ul>
  </div>

  <!-- Toast Notification Container -->
  <p-toast></p-toast>

  <!-- Premium AI Model Selector (Glassmorphism design at the bottom-left sidebar) -->
  <div class="model-selector-wrapper" [class.collapsed]="!sidebarVisibility">
    
    <!-- Expanded view -->
    <ng-container *ngIf="sidebarVisibility">
      <div class="model-info">
        <div class="model-label-container">
          <svg class="ai-spark-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
          </svg>
          <span class="model-label">Active Model</span>
        </div>
      </div>
      <div class="model-dropdown-container">
        <p-dropdown 
          [options]="modelsList" 
          [(ngModel)]="selectedModel" 
          [disabled]="isApiFlight"
          (onChange)="onModelChange($event)"
          styleClass="sidebar-model-dropdown"
          placeholder="Select Model"
          [class.api-flight]="isApiFlight">
        </p-dropdown>
      </div>
    </ng-container>

    <!-- Collapsed view -->
    <ng-container *ngIf="!sidebarVisibility">
      <div class="collapsed-trigger" [pTooltip]="'Active Model: ' + (selectedModel || 'Select')" tooltipPosition="right">
        <p-dropdown 
          [options]="modelsList" 
          [(ngModel)]="selectedModel" 
          [disabled]="isApiFlight"
          (onChange)="onModelChange($event)"
          styleClass="sidebar-model-dropdown-collapsed"
          [dropdownIcon]="'pi pi-cog'"
          [class.api-flight]="isApiFlight">
        </p-dropdown>
      </div>
    </ng-container>

  </div>
</div>
